import axios from "axios";
import { Apis, BaseUrl } from "../../config";
import { getSession } from "../authActions";

export const getSenders = () => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "sender_List_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.senderList}/sndrcvid/?sender_id=${user_profile_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id },
      }
    );
    dispatch({ type: "sender_List_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "sender_List_failure",
      payload: error.response.data,
    });
  }
};

export const getSendersChats = (reciversID) => async (dispatch) => {
  const { token, user_profile_id, role_id } = getSession();

  dispatch({ type: "sender_Message_req" });
  try {
    const response = await axios.get(
      `${BaseUrl}${Apis.senderList}/btwnsndrcvid/?sender_id=${user_profile_id}&receiver_id=${reciversID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { sys_user_id: user_profile_id, role_id: role_id },
      }
    );
    dispatch({ type: "sender_Message_success", payload: response.data });
  } catch (error) {
    dispatch({
      type: "sender_Message_failure",
      payload: error.response.data,
    });
  }
};

export const sendMessage = (payload) => async (dispatch) => {
  const { token } = getSession();
  try {
    const response = await axios.post(`${BaseUrl}${Apis.senderList}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch({ type: "send_Message", payload: response.data });
  } catch (error) {
    throw error;
  }
};
